import React, { useState } from "react";
import { withRouter } from "react-router-dom";
import { Card } from "react-bootstrap";

import MainBreadcrumb from "app/views/custom/components/MainBreadcrumb";
import TrainingFormUI from "./Component/TrainingFormUI";
import FormBtn from "app/Components/CommanComponents/FormBtn";
import { createTrainingBatch } from "app/_services/ehs/ehsTrainingServices";
import { Validation } from "app/_helpers/validation/Validation";
import toastr from "toastr";
import { TRAINING_TYPE, trainerTypeObj } from "../CONSTANTS";
import { LOGGED_IN_USER_SITE_ID } from "../../IncidentManagement/Helper";

const initialForm = {
  traineeIds: "",
  centerName: "",
  centerCode: "",
  areaId: "",
  trainingCategory: "",
  trainingSubCategory: "",
  // site: "",
  trainingDate: "",
  duration: "",
  trainingType: TRAINING_TYPE.other,
  traineeType: "",
  traineeId: "",
  batchId: "",
  trainingId: "",
  comment: "",
  trainingCompleteDate: "",
  feedbackTestFile: null,
  feedbackTestFileId: null,
  trainingHours: "",
  descriptionOther: "",
  endDate: "",
  session: "",
  trainerId: "",
  trainerName: "",
  trainerType: "",
};

const staffListObj = {
  traineeId: "",
  staffType: "",
};

const staffListRules = [
  {
    field_name: "staffType",
    label: "Trainee Type",
    type: "string",
    isRequired: true,
  },
  {
    field_name: "traineeId",
    label: "Trainee Name",
    type: "string",
    isRequired: true,
  },
];

const otherStaffListObj = {
  name: "",
};

const otherStaffRules = [
  {
    field_name: "name",
    label: "Trainee Name",
    type: "string",
    isRequired: true,
  },
];

const rules = [
  {
    field_name: "centerName",
    label: "Name of Center",
    type: "string",
    isRequired: true,
  },
  {
    field_name: "centerCode",
    label: "Center Code",
    type: "string",
    isRequired: true,
  },
  // {
  //   field_name: "traineeType",
  //   label: "Trainee Type",
  //   type: "string",
  //   isRequired: true,
  // },
  // {
  //   field_name: "traineeId",
  //   label: "Trainee",
  //   type: "string",
  //   isRequired: true,
  // },
  {
    field_name: "areaId",
    label: "Site Specific Area",
    type: "string",
    isRequired: true,
  },
  {
    field_name: "duration",
    label: "Duration",
    type: "number",
    isRequired: true,
  },
  {
    field_name: "trainingHours",
    label: "Training Hours",
    type: "number",
    isRequired: true,
  },
  {
    field_name: "trainingDate",
    label: "Date of Training",
    type: "string",
    isRequired: true,
  },
  {
    field_name: "trainingCategory",
    label: "Category",
    type: "string",
    isRequired: true,
  },
  {
    field_name: "trainingSubCategory",
    label: "Sub Category",
    type: "string",
    isRequired: true,
  },
  {
    field_name: "trainingId",
    label: "Training ID",
    type: "string",
    isRequired: true,
  },
  {
    field_name: "batchId",
    label: "Batch ID",
    type: "string",
    isRequired: true,
  },
  // {
  //   field_name: "trainingCompleteDate",
  //   label: "Completion Date",
  //   type: "string",
  //   isRequired: true,
  // },
  {
    field_name: "comment",
    label: "Comment",
    type: "string",
    isRequired: true,
  },
  {
    field_name: "descriptionOther",
    label: "Description",
    type: "string",
    isRequired: true,
  },
  {
    field_name: "endDate",
    label: "End Date Of Training",
    type: "string",
    isRequired: true,
  },
  {
    field_name: "trainerType",
    label: "Trainer Type",
    type: "string",
    isRequired: true,
  },
];

const trainerIdRules = {
  field_name: "trainerId",
  label: "Trainer Name",
  type: "string",
  isRequired: true,
};

const trainerNameRules = {
  field_name: "trainerName",
  label: "Trainer Name",
  type: "string",
  isRequired: true,
};

const AssignNewTraining = ({
  match: {
    params: { id, siteId },
  },
  history,
}) => {
  const [form, setForm] = useState({ ...initialForm });
  const [staffList, setStaffList] = useState([{ ...staffListObj }]);
  const [staffError, setStaffError] = useState([]);
  const [otherStaffList, setOtherStaffList] = useState([]);
  const [otherStaffError, setOtherStaffError] = useState([]);
  const [error, setError] = useState({});

  const onChangeStaff = ({ target: { name, value } }, index) =>
    setStaffList((prev) =>
      prev.map((data, idx) => {
        if (idx !== index) return data;
        data[name] = value;
        if (name === "staffType") {
          data.traineeId = null;
        }
        return data;
      })
    );

  const addRow = () => {
    setStaffList((prev) => [...prev, { ...staffListObj }]);
  };
  const deleteRow = (index) =>
    setStaffList((prev) => {
      prev.splice(index, 1);
      return [...prev];
    });

  const onChangeOtherStaff = ({ target: { name, value } }, index) =>
    setOtherStaffList((prev) =>
      prev.map((data, idx) => {
        if (idx !== index) return data;
        data[name] = value;
        return data;
      })
    );

  const addOtherStaff = () => {
    setOtherStaffList((prev) => [...prev, { ...otherStaffListObj }]);
  };
  const deleteOtherStaff = (index) =>
    setOtherStaffList((prev) => {
      prev.splice(index, 1);
      return [...prev];
    });

  const onChange = ({ target: { name, value } }) => {
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const onFileChange = (_event, responseData) => {
    setForm((prev) => ({
      ...prev,
      feedbackTestFileId: responseData?.id,
      feedbackTestFile: responseData,
    }));
  };
  const deleteDocumentFile = (_event, _index) => {
    setForm((prev) => ({ ...prev, feedbackTestFileId: null, feedbackTestFile: null }));
  };

  // ************* Submit ********
  const onSubmit = async () => {
    let flag = 0;
    let finalRules = rules;
    if (!form?.trainerType || form?.trainerType === trainerTypeObj.internal) {
      !finalRules.find((o) => o.field_name === "trainerId") &&
        finalRules.push(trainerIdRules);
      finalRules = finalRules.filter((d) => d.field_name !== "trainerName");
    }
    if (form?.trainerType === trainerTypeObj.external) {
      !finalRules.find((o) => o.field_name === "trainerName") &&
        finalRules.push(trainerNameRules);
      finalRules = finalRules.filter((d) => d.field_name !== "trainerId");
    }
    const errorObj = Validation(form, finalRules);

    const errorArray = staffList.map((data) => Validation(data, staffListRules));
    const errorOtherStaff = otherStaffList?.length
      ? otherStaffList.map((data) => Validation(data, otherStaffRules))
      : [];

    setError(errorObj);
    setStaffError(errorArray);
    setOtherStaffError(errorOtherStaff);

    for (const errObj of errorArray)
      for (const key in errObj)
        if (errObj[key]) {
          flag = 1;
          break;
        }

    for (const errObj of errorOtherStaff)
      for (const key in errObj)
        if (errObj[key]) {
          flag = 1;
          break;
        }

    if (flag || Object.values(errorObj).filter((d) => d !== "").length) return;

    let duplicateId = [];
    let dulicateFlag = 0;
    staffList.forEach((obj) => {
      let uniqueKey = obj?.traineeId + obj?.staffType;
      if (!duplicateId.includes(uniqueKey)) {
        duplicateId.push(uniqueKey);
      } else dulicateFlag++;
    });

    if (dulicateFlag) {
      toastr.error("Trainee Type and Trainee Name should not duplicate.");
      return;
    }

    const formData = {
      ...form,
      // traineeIds: [form?.traineeId],
      traineeIds: staffList,
      otherStaffData: otherStaffList,
      site: LOGGED_IN_USER_SITE_ID(),
    };

    let response = await createTrainingBatch(formData);

    if (!response?.status) return toastr.error(response?.message);

    toastr.success("Training successfully added");

    history.push(`/health-safety-and-environment/training-management`);
  };

  return (
    <div>
      <MainBreadcrumb
        routeSegments={[
          { name: "Health Safety And Environment", path: "#" },
          {
            name: "Training Management",
            path:
              (siteId ? `/sites/${siteId}` : "") +
              "/health-safety-and-environment/training-management",
          },
          {
            name: "Schedule Training",
            path: "/health-safety-and-environment/training-management/assign?tab=2",
          },
          {
            name: "Assign Training",
            path:
              (siteId ? `/sites/${siteId}` : "") +
              "/health-safety-and-environment/training-management/assign?tab=5",
          },
          { name: `${id ? "Update" : "Add"} Training Assigners` },
        ]}
      />

      <Card className="overflow-inherit">
        <Card.Body>
          <Card.Title className="simple-card-title">
            <h3 class="text-capitalize mb-1">{id ? "Edit" : "Add"} Training</h3>
          </Card.Title>

          <TrainingFormUI
            form={form}
            error={error}
            onChange={onChange}
            onFileChange={onFileChange}
            deleteDocumentFile={deleteDocumentFile}
            staffList={staffList}
            addRow={addRow}
            deleteRow={deleteRow}
            onChangeStaff={onChangeStaff}
            staffError={staffError}
            otherStaffList={otherStaffList}
            addOtherStaff={addOtherStaff}
            deleteOtherStaff={deleteOtherStaff}
            onChangeOtherStaff={onChangeOtherStaff}
            otherStaffError={otherStaffError}
          />

          <FormBtn
            id={id}
            onSubmit={onSubmit}
            // backUrl={"/user-management/employee"}
          />
        </Card.Body>
      </Card>
    </div>
  );
};

export default withRouter(AssignNewTraining);
